export class ApiStateData {
  loading = false;
  errorType = "";

  constructor(fields?: Partial<ApiStateData>) {
    Object.assign(this, fields);
  }
}
